import React from 'react';
import InfoCard from 'components/InfoCard';
import styles from './InfoCards.module.scss';

type InfoData = string | number | Array<unknown> | { value?: unknown; count?: number } | null | undefined;

export type InfoItem = {
    key?: string;
    title: string;
    description?: string;
    data?: InfoData;
};

export type InfoCardsProps = {
    infos?: InfoItem[] | Record<string, InfoItem>;
};

/**
 * Renders multiple InfoCard components based on the provided infos
 * @param {Object|Array} infos - Either an object with info items or an array of info items
 * @returns {JSX.Element} - A container with InfoCard components
 */
const InfoCards = ({ infos }: InfoCardsProps) => {
    const renderInfoCards = () => {
        if (!infos) return null;

        // Handle both array and object formats of infos
        if (Array.isArray(infos)) {
            return infos.map((info, index) => (
                <InfoCard
                    key={info.key || info.title || index}
                    title={info.title}
                    description={info.description}
                    data={info.data}
                />
            ));
        } else if (typeof infos === 'object') {
            return Object.entries(infos).map(([key, info]) => (
                <InfoCard key={info.key || key} title={info.title} description={info.description} data={info.data} />
            ));
        }

        return null;
    };

    return <>{renderInfoCards()}</>;
};

export default InfoCards;
